import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../componentes/Plantilla/Plantilla';
import HeroSection from '../componentes/Portada/SeccionPortada';
import HistorySection from '../componentes/Secciones/Historia/SeccionHistoria';
import ServicesSection from '../componentes/Secciones/Servicios/SeccionServicios';
import ProductsSection from '../componentes/Secciones/Productos/SeccionProductos';
import ProjectsSection from '../componentes/Secciones/Proyectos/SeccionProyectos';
import BrandsSection from '../componentes/Secciones/Marcas/SeccionMarcas';
import ClientsSection from '../componentes/Secciones/Clientes/SeccionClientes';
import LocationSection from '../componentes/Secciones/Ubicacion/SeccionUbicacion';
import VideosSection from '../componentes/Secciones/Videos/SeccionVideos';
import ContactSection from '../componentes/Secciones/Contacto/SeccionContacto';
import FAQ from '../componentes/Secciones/PreguntasFrecuentes/PreguntasFrecuentes';

export const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.substring(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location]);
  return (
    <Layout>
      <HeroSection />
      <HistorySection />
      <ServicesSection />
      <ProductsSection />
      <ProjectsSection />
      <BrandsSection />
      <LocationSection />
      <ClientsSection />
      <VideosSection />
      <ContactSection />
      <FAQ />
    </Layout>
  );
};
export default Home;
